import axios from 'axios';
import { parseException } from './util';

export async function getFolders(accessToken: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.get('/api/folder');
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function createFolder(accessToken: string, name: string, parentFolderId?: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.post(`/api/folder/create?parentFolderId=${parentFolderId ? parentFolderId : ''}&name=${name}`);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function renameFolder(accessToken: string, name: string, folderId: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.post(`/api/folder/${folderId}/rename?name=${name}`);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function moveFolder(accessToken: string, folderId: string, newFolderId?: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.post(`/api/folder/move/${folderId}?newFolderId=${newFolderId ? newFolderId : ''}`);
		return response.data;
	} catch (error) {
		throw parseException(error);
	}
}

export async function deleteFolder(accessToken: string, folderId: string) {
    try {
		const instance = axios.create({
			headers: {
				Authorization: 'Bearer ' + accessToken
			}
		});
		const response = await instance.delete(`/api/folder/${folderId}`);
		return response.data;
	} catch (error: any) {
		throw parseException(error);
	}
}